@file:OptIn(InternalResourceApi::class)

package top.clientapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.clientapp.generated.resources/"

@delegate:ResourceContentHash(986_286_497)
internal val Res.string.venue_category_tuning_detailing: StringResource by lazy {
      StringResource("string:venue_category_tuning_detailing", "venue_category_tuning_detailing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25102, 83),
      ))
    }

@delegate:ResourceContentHash(-577_422_576)
internal val Res.string.venue_category_tutoring: StringResource by lazy {
      StringResource("string:venue_category_tutoring", "venue_category_tutoring", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25186, 59),
      ))
    }

@delegate:ResourceContentHash(1_695_166_720)
internal val Res.string.venue_category_university_college: StringResource by lazy {
      StringResource("string:venue_category_university_college", "venue_category_university_college", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25246, 97),
      ))
    }

@delegate:ResourceContentHash(-83_255_307)
internal val Res.string.venue_category_ux_ui_design: StringResource by lazy {
      StringResource("string:venue_category_ux_ui_design", "venue_category_ux_ui_design", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25344, 67),
      ))
    }

@delegate:ResourceContentHash(-715_750_879)
internal val Res.string.venue_category_vehicle_rental: StringResource by lazy {
      StringResource("string:venue_category_vehicle_rental", "venue_category_vehicle_rental", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25412, 93),
      ))
    }

@delegate:ResourceContentHash(-168_975_334)
internal val Res.string.venue_category_vet_services: StringResource by lazy {
      StringResource("string:venue_category_vet_services", "venue_category_vet_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25506, 63),
      ))
    }

@delegate:ResourceContentHash(3_528_478)
internal val Res.string.venue_category_veterinary_clinic: StringResource by lazy {
      StringResource("string:venue_category_veterinary_clinic", "venue_category_veterinary_clinic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25570, 92),
      ))
    }

@delegate:ResourceContentHash(-1_378_912_546)
internal val Res.string.venue_category_warehousing: StringResource by lazy {
      StringResource("string:venue_category_warehousing", "venue_category_warehousing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25663, 78),
      ))
    }

@delegate:ResourceContentHash(-130_110_834)
internal val Res.string.venue_category_waste_removal: StringResource by lazy {
      StringResource("string:venue_category_waste_removal", "venue_category_waste_removal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25742, 96),
      ))
    }

@delegate:ResourceContentHash(1_197_650_206)
internal val Res.string.venue_category_web_development: StringResource by lazy {
      StringResource("string:venue_category_web_development", "venue_category_web_development", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25839, 90),
      ))
    }

@delegate:ResourceContentHash(-972_772_769)
internal val Res.string.venue_category_windows_doors: StringResource by lazy {
      StringResource("string:venue_category_windows_doors", "venue_category_windows_doors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25930, 92),
      ))
    }

@delegate:ResourceContentHash(1_744_636_745)
internal val Res.string.venue_group_auto: StringResource by lazy {
      StringResource("string:venue_group_auto", "venue_group_auto", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26023, 36),
      ))
    }

@delegate:ResourceContentHash(-1_404_032_480)
internal val Res.string.venue_group_beauty: StringResource by lazy {
      StringResource("string:venue_group_beauty", "venue_group_beauty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26060, 66),
      ))
    }

@delegate:ResourceContentHash(-1_913_255_598)
internal val Res.string.venue_group_business: StringResource by lazy {
      StringResource("string:venue_group_business", "venue_group_business", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26127, 112),
      ))
    }

@delegate:ResourceContentHash(-1_130_742_008)
internal val Res.string.venue_group_education: StringResource by lazy {
      StringResource("string:venue_group_education", "venue_group_education", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26240, 77),
      ))
    }

@delegate:ResourceContentHash(1_274_836_302)
internal val Res.string.venue_group_entertainment: StringResource by lazy {
      StringResource("string:venue_group_entertainment", "venue_group_entertainment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26318, 81),
      ))
    }

@delegate:ResourceContentHash(1_476_817_762)
internal val Res.string.venue_group_events: StringResource by lazy {
      StringResource("string:venue_group_events", "venue_group_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26400, 62),
      ))
    }

@delegate:ResourceContentHash(-1_867_152_938)
internal val Res.string.venue_group_food: StringResource by lazy {
      StringResource("string:venue_group_food", "venue_group_food", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26463, 72),
      ))
    }

@delegate:ResourceContentHash(1_148_396_627)
internal val Res.string.venue_group_health: StringResource by lazy {
      StringResource("string:venue_group_health", "venue_group_health", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26536, 78),
      ))
    }

@delegate:ResourceContentHash(1_128_306_451)
internal val Res.string.venue_group_home: StringResource by lazy {
      StringResource("string:venue_group_home", "venue_group_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26615, 112),
      ))
    }

@delegate:ResourceContentHash(336_578_466)
internal val Res.string.venue_group_household: StringResource by lazy {
      StringResource("string:venue_group_household", "venue_group_household", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26728, 73),
      ))
    }

@delegate:ResourceContentHash(1_714_215_639)
internal val Res.string.venue_group_it_media: StringResource by lazy {
      StringResource("string:venue_group_it_media", "venue_group_it_media", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26802, 80),
      ))
    }

@delegate:ResourceContentHash(846_177_088)
internal val Res.string.venue_group_logistics: StringResource by lazy {
      StringResource("string:venue_group_logistics", "venue_group_logistics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26883, 81),
      ))
    }

@delegate:ResourceContentHash(-111_085_589)
internal val Res.string.venue_group_pets: StringResource by lazy {
      StringResource("string:venue_group_pets", "venue_group_pets", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26965, 68),
      ))
    }

@delegate:ResourceContentHash(719_782_378)
internal val Res.string.venue_group_shopping: StringResource by lazy {
      StringResource("string:venue_group_shopping", "venue_group_shopping", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27034, 76),
      ))
    }

@delegate:ResourceContentHash(-66_497_695)
internal val Res.string.venue_group_travel: StringResource by lazy {
      StringResource("string:venue_group_travel", "venue_group_travel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27111, 82),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("venue_category_tuning_detailing", Res.string.venue_category_tuning_detailing)
  map.put("venue_category_tutoring", Res.string.venue_category_tutoring)
  map.put("venue_category_university_college", Res.string.venue_category_university_college)
  map.put("venue_category_ux_ui_design", Res.string.venue_category_ux_ui_design)
  map.put("venue_category_vehicle_rental", Res.string.venue_category_vehicle_rental)
  map.put("venue_category_vet_services", Res.string.venue_category_vet_services)
  map.put("venue_category_veterinary_clinic", Res.string.venue_category_veterinary_clinic)
  map.put("venue_category_warehousing", Res.string.venue_category_warehousing)
  map.put("venue_category_waste_removal", Res.string.venue_category_waste_removal)
  map.put("venue_category_web_development", Res.string.venue_category_web_development)
  map.put("venue_category_windows_doors", Res.string.venue_category_windows_doors)
  map.put("venue_group_auto", Res.string.venue_group_auto)
  map.put("venue_group_beauty", Res.string.venue_group_beauty)
  map.put("venue_group_business", Res.string.venue_group_business)
  map.put("venue_group_education", Res.string.venue_group_education)
  map.put("venue_group_entertainment", Res.string.venue_group_entertainment)
  map.put("venue_group_events", Res.string.venue_group_events)
  map.put("venue_group_food", Res.string.venue_group_food)
  map.put("venue_group_health", Res.string.venue_group_health)
  map.put("venue_group_home", Res.string.venue_group_home)
  map.put("venue_group_household", Res.string.venue_group_household)
  map.put("venue_group_it_media", Res.string.venue_group_it_media)
  map.put("venue_group_logistics", Res.string.venue_group_logistics)
  map.put("venue_group_pets", Res.string.venue_group_pets)
  map.put("venue_group_shopping", Res.string.venue_group_shopping)
  map.put("venue_group_travel", Res.string.venue_group_travel)
}
